import React, {Component} from 'react';
import {Buffer} from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import {SourceStockDataTypes} from "./types/SourceStockDataTypes";
import withAuth from "../../hoc/withAuth";
import {Button, Modal, Table, Tag, Tooltip} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import {dataSource} from "../../config/data/amartaStock";
import Cookies from "universal-cookie";

export interface SourceStockDataProps {
}

class SourceStockData extends Component<SourceStockDataProps & any, SourceStockDataTypes> {
    private readonly initState!: SourceStockDataTypes;
    private uDealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString());

    private tableColumn: any = [
        {
            title: 'Kode Entitas',
            dataIndex: 'dealer_code',
            width: 200,
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{value}</span>
            })
        }, {
            title: 'Nama Entitas',
            dataIndex: 'dealer_name',
            width: 300,
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{value}</span>
            })
        }, {
            title: 'Lokasi Data',
            dataIndex: 'data_location',
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{value}</span>
            })
        }, {
            title: 'Action',
            key: 'operation',
            fixed: 'right',
            width: 150,
            render: ((row: any) => {
                return <span className={`font-90`}>
                    <Tooltip placement="topLeft" title="Lihat Data">
                        <Tag icon={<SearchOutlined/>} color="#55acee" onClick={event => this.detailJson(row)} style={{cursor: "pointer"}}> Lihat Data </Tag>
                    </Tooltip>
                </span>
            })
        }
    ];
    private detailColumn: any = [
        {
            title: 'Kode Variant',
            dataIndex: 'vehicle_variant_code',
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{value}</span>
            })
        }, {
            title: 'Nama Variant',
            dataIndex: 'vehicle_variant_name',
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{value}</span>
            })
        }, {
            title: 'Kode warna',
            dataIndex: 'vehicle_color_code',
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{value}</span>
            })
        }, {
            title: 'Nama warna',
            dataIndex: 'vehicle_color_name',
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{value}</span>
            })
        }, {
            title: 'Qty',
            dataIndex: 'stock_qty',
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{value}</span>
            })
        }
    ];

    constructor(props: SourceStockDataProps & any | any) {
        super(props);
        const finalDealerCode = props?.match?.params?.dealerCode?.replace(/-/g, '#');
        const picked = this.uDealer.find((o: { DealerCode: any; }) => o.DealerCode === finalDealerCode);
        const companyCode = picked?.DealerCompany ?? "AMARTA";

        this.initState = {
            companyCode: companyCode,
            processingFetchTableData: true,
            showModal: false,
            modalTitle: "",
            lastUpdate: "",
            dataTable: [],
            detailTable: [],
        }
        this.state = {...this.initState}
    }

    detailJson = async (data: any) => {
        this.setState({
            showModal: true,
            modalTitle: data.dealer_name,
        })

        const fetch = require('node-fetch');
        let url = data.data_location;
        let settings = {method: "Get"};

        fetch(url, settings)
            .then((res: { json: () => any; }) => res.json())
            .then((json: any) => {
                const stockDataByVariantColor: any = {};
                for (const item of json.list_data) {
                    if (stockDataByVariantColor[`${item.vehicle_variant_code}${item.vehicle_color_code}`]) {
                        stockDataByVariantColor[`${item.vehicle_variant_code}${item.vehicle_color_code}`]['stock_qty'] += 1
                    } else {
                        stockDataByVariantColor[`${item.vehicle_variant_code}${item.vehicle_color_code}`] = {};
                        stockDataByVariantColor[`${item.vehicle_variant_code}${item.vehicle_color_code}`]['key'] = `${item.vehicle_variant_code}${item.vehicle_color_code}`;
                        stockDataByVariantColor[`${item.vehicle_variant_code}${item.vehicle_color_code}`]['vehicle_variant_code'] = item.vehicle_variant_code;
                        stockDataByVariantColor[`${item.vehicle_variant_code}${item.vehicle_color_code}`]['vehicle_variant_name'] = item.vehicle_variant_name;
                        stockDataByVariantColor[`${item.vehicle_variant_code}${item.vehicle_color_code}`]['vehicle_color_code'] = item.vehicle_color_code;
                        stockDataByVariantColor[`${item.vehicle_variant_code}${item.vehicle_color_code}`]['vehicle_color_name'] = item.vehicle_color_name;
                        stockDataByVariantColor[`${item.vehicle_variant_code}${item.vehicle_color_code}`]['stock_qty'] = 1;
                    }
                }

                this.setState({
                    lastUpdate: json?.created_time?.replace('T', ' '),
                    detailTable: Object.entries(stockDataByVariantColor).map(([key, value]) => (value)),
                });
            }).catch((e: any) => {
            console.log(e);
            this.setState({
                lastUpdate: "Error",
                detailTable: []
            })
        });
    }

    fetchData = () => {
        const stockData = [];
        for (const item of dataSource) {
            if (item.company_code === this.state.companyCode) {
                stockData.push(item);
            }
        }

        this.setState({
            dataTable: stockData,
            processingFetchTableData: false,
        });
    }

    async componentDidMount() {
        await this.fetchData();
    }

    onDealerChange = async (data: any) => {

    }

    render() {
        return (
            <>
                <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={`Stock`} breadcrumbMenu={`Publish Stock`} defaultSelectedKeys={['m-publish-stock']} defaultOpenKeys={['sm-stock', 'sm-sm-stock-json']}>
                    <div style={{float: "right", fontSize: "85%", color: "grey"}}>Organization: {this.state.companyCode}</div>
                    <br/>
                    <Table
                        rowKey={'dealer_code'}
                        size={'small'}
                        scroll={{x: 'calc(500px + 50%)'}}
                        loading={this.state.processingFetchTableData}
                        columns={this.tableColumn}
                        dataSource={this.state.dataTable}
                        pagination={{pageSize: 100}}
                    />

                    <Modal
                        title={this.state.modalTitle}
                        open={this.state.showModal}
                        onOk={() => this.setState({showModal: false})}
                        onCancel={() => this.setState({showModal: false})}
                        width={'80%'}
                        footer={[<Button type="primary" onClick={() => this.setState({showModal: false})}>Close</Button>]}
                    >
                        <p>Last Update: {this.state.lastUpdate}</p>
                        <Table
                            rowKey={'key'}
                            size={'small'}
                            scroll={{x: 'calc(500px + 50%)'}}
                            loading={this.state.processingFetchTableData}
                            columns={this.detailColumn}
                            dataSource={this.state.detailTable}
                            pagination={{pageSize: 100}}
                        />
                    </Modal>
                </MainLayout>
            </>
        );
    }
}

export default withAuth(withRouter(SourceStockData), 26);